import * as Sentry from "@sentry/react";
import { LOGGER_DISABLED } from "./constants";
import { inject } from "@vercel/analytics";

const Logger = {
  init: () => {
    if (LOGGER_DISABLED) return;

    inject();
    Sentry.init({
      dsn: "https://178d58769f1fec923b042fdcbc12d0df@o4504130649718784.ingest.sentry.io/4505681558503424",
      integrations: [
        new Sentry.BrowserTracing({
          // Supabase only allows authorization, x-client-info, apikey and
          // content-type. Attaching sentry-trace and baggage makes every
          // cross-origin call fail the CORS preflight.
          tracePropagationTargets: [
            "localhost",
            /^https:\/\/(www\.)?pinpadel\.app/,
            "https://pinpadel.vercel.app",
          ],
        }),
        new Sentry.Replay(),
      ],
      tracesSampleRate: 1.0,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    });
  },
};

export { Logger };
